// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/zoom';
import Swiper from 'swiper';
import { EffectFade, Keyboard, Mousewheel, Navigation, Pagination, Thumbs, Zoom } from 'swiper/modules';
import { commonUtils } from './common_utils';

const fullscreenEventNames = [
    'fullscreenchange',
    'webkitfullscreenchange',
    'mozfullscreenchange',
    'MSFullscreenChange',
];

function fullscreenChangeHandler() {
    if (!commonUtils.fullscreen.isActive() && $('body').hasClass('swiper-large-image-visible')) {
        $('body').removeClass('swiper-large-image-visible');
        $('.swiperLarge').hide();
        const mainSwiper = $('.swiperDetailPage')[0]?.swiper;
        mainSwiper?.keyboard?.enable();
    }
}

const imageSlider = {
    init() {
        const thumbsSwiper = new Swiper('.swiperThumb', {
            modules: [Thumbs],
            slidesPerView: 6,
            spaceBetween: 4,
            loop: false,
            lazy: true,
            lazyPreloadPrevNext: 2,
        });

        const swiperDetail = new Swiper('.swiperDetailPage', {
            modules: [Navigation, Pagination, Thumbs, EffectFade, Keyboard],
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true, // This is crucial for preventing overlap
            },
            speed: 0,
            loop: true,
            lazy: true,
            lazyPreloadPrevNext: 2,
            keyboard: {
                enabled: true,
                pageUpDown: false,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'custom',
                renderCustom(swiper, current, total) {
                    return `${current}/${total}`;
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                addIcons: false,
            },
            thumbs: {
                swiper: thumbsSwiper,
            },
            on: {
                init() {
                    // Store the swiper instance in a data attribute for easy access
                    $('.swiperDetailPage')[0].swiper = this;
                },
                slideChange(swiper) {
                    let $openFullScreen = $('#openFullScreen');
                    $openFullScreen.hide();
                    $('a[id^=zoom_image_]').hide();
                    if ($('.imageRows').data('image-slider-start-to') === 2 && swiper.realIndex === 0) {
                        $openFullScreen.show();
                    } else {
                        $(`#zoom_image_${swiper.realIndex}`).show();
                    }

                    imageSlider.moveSliderImage();
                },
            },
        });

        const enableMainSwiperKeyboard = function () {
            const mainSwiper = $('.swiperDetailPage')[0].swiper;
            if (mainSwiper && mainSwiper.keyboard) {
                mainSwiper.keyboard.enable();
            }
        };

        let $body = $('body');
        $body.on('click', '.showAllThumbnails', function () {
            $('.parentThumbnail').addClass('swiper-large-slider__show-all');
        });

        // For mobile view, Show/Hide image button
        $body.on('click', '.showImagesInSmallLayout', function (e) {
            e.preventDefault();
            imageSlider.showImages();
            swiperDetail.slideTo($('.imageRows').data('image-slider-start-to'));
        });

        // Play video when click on video icon
        $body.on('click', '.playVideoButton', function () {
            imageSlider.playVideoInPopup($(this).data('video-url'), $(this).data('video-type'));
        });

        // Play video on page load
        setTimeout(function () {
            let $videoIcon = $('.playVideoButton');
            if ($videoIcon.data('video-display')) {
                imageSlider.playVideoInPopup($videoIcon.data('video-url'), $videoIcon.data('video-type'));
            }
        }, 1000);

        // Open full screen mode for 360 image
        $body.on('click', '#openFullScreen', function () {
            commonUtils.fullscreen.open(document.getElementById('videoFrame'));
            return false;
        });

        // For article page only
        $body.on('click', '.playVideoButtonForArticle', function () {
            imageSlider.playVideoOnImage($(this).data('video-url'), $(this).data('video-type'));
            setTimeout(function () {
                $('.swiper-wrapper .swiper-slide-thumb-active').removeClass('swiper-slide-thumb-active');
            }, 1000);
        });

        // Handle fullscreen mode
        $body.on('click', '.swiperLargeFullscreenImage>button', function () {
            // Request HTML fullscreen on the swiper container
            const swiperContainer = $('.swiperLarge')[0];
            if (swiperContainer) {
                commonUtils.fullscreen.open(swiperContainer);
            }

            // Show the fullscreen slider
            $('.swiperLarge').show();
            $body.addClass('swiper-large-image-visible');

            // Disable main swiper keyboard to prevent conflicts
            const mainSwiper = $('.swiperDetailPage')[0].swiper;
            if (mainSwiper && mainSwiper.keyboard) {
                mainSwiper.keyboard.disable();
            }

            // Destroy existing instance if it exists
            const swiperLargeEl = $('.swiperLarge')[0];
            if (swiperLargeEl && swiperLargeEl.swiper) {
                swiperLargeEl.swiper.destroy(true, true);
            }

            // Get the image count
            const imageCount = $('.swiperLarge .swiper-slide').length;

            // Reinitialize with proper navigation
            const swiperLarge = new Swiper('.swiperLarge', {
                modules: [Navigation, Pagination, Thumbs, EffectFade, Keyboard, Zoom, Mousewheel],
                loop: imageCount > 1, // Only enable loop if there's more than one image
                slidesPerView: 1,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true, // This is crucial for preventing overlap
                },
                lazy: true,
                lazyPreloadPrevNext: 2,
                speed: 0,
                mousewheel: {
                    sensitivity: 1.2, // More responsive than 0.3
                    thresholdDelta: 5, // Lower threshold for quicker response
                    thresholdTime: 250,
                },
                zoom: {
                    minRatio: 1,
                    maxRatio: 3,
                    toggle: true,
                    containerClass: 'swiperZoomContainer',
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                pagination: {
                    el: '.swiper-pagination-large',
                    type: 'custom',
                    renderCustom(swiper, current, total) {
                        return `${current}/${total}`;
                    },
                },
                navigation: {
                    nextEl: '.swiper-button-next-large',
                    prevEl: '.swiper-button-prev-large',
                    addIcons: false,
                },
                on: {
                    init() {
                        // Store the swiper instance for later reference
                        $('.swiperLarge')[0].swiper = this;

                        // Set to the current index of the normal slider
                        const currentIndex = $('.swiperDetailPage')[0].swiper.realIndex;

                        // Check if there's a video icon (which would create an offset in indexing)
                        const hasVideo = $('.playVideoButtonForArticle').length > 0;

                        // If there's a video icon and we're not on the video slide (index 0),
                        // we need to adjust the index because fullscreen slider doesn't have the video slide
                        let adjustedIndex = currentIndex;
                        if (hasVideo && currentIndex > 0) {
                            // Adjust index by -1 to account for the missing video slide in fullscreen
                            adjustedIndex = currentIndex - 1;
                        }

                        this.slideTo(adjustedIndex, 0);
                    },
                    beforeDestroy() {
                        this.zoom.out();
                    },
                },
            });

            // Add event listener for Escape key to close the fullscreen slider
            const handleEscKey = function (event) {
                if (event.key === 'Escape' || event.keyCode === 27) {
                    if (commonUtils.fullscreen.isActive()) {
                        commonUtils.fullscreen.exit();
                    }

                    fullscreenEventNames.forEach((fullScreenEvent) =>
                        document.removeEventListener(fullScreenEvent, fullscreenChangeHandler)
                    );

                    $('.swiperLarge').hide();
                    $body.removeClass('swiper-large-image-visible');

                    // Re-enable main swiper keyboard
                    enableMainSwiperKeyboard();

                    // Remove the event listener when the slider is closed
                    document.removeEventListener('keydown', handleEscKey);
                }
            };

            // Add the event listener
            document.addEventListener('keydown', handleEscKey);

            // Apply custom changes for scroll + laptop touch-pad pinch zoom
            // Detect pinch/zoom gestures
            let isPinching = false;

            // Check for gesture start (pinch start)
            swiperLarge.el.addEventListener(
                'gesturestart',
                (e) => {
                    e.preventDefault();
                    isPinching = true;
                },
                { passive: false }
            );

            // Check for gesture end
            swiperLarge.el.addEventListener(
                'gestureend',
                (e) => {
                    e.preventDefault();
                    isPinching = false;
                },
                { passive: false }
            );

            // Handle wheel events
            swiperLarge.el.addEventListener(
                'wheel',
                (e) => {
                    // If it's a zoom gesture (Ctrl/Cmd + wheel or during pinch)
                    if (isPinching || e.ctrlKey || e.metaKey) {
                        // Let the zoom behavior happen naturally
                        swiperLarge.mousewheel.disable();
                        return;
                    }

                    // Re-enable mousewheel if we're not zooming
                    if (!swiperLarge.mousewheel.enabled) {
                        swiperLarge.mousewheel.enable();
                    }
                },
                { passive: true }
            );

            fullscreenEventNames.forEach((fullScreenEvent) =>
                document.addEventListener(fullScreenEvent, fullscreenChangeHandler)
            );
        });

        // Close fullscreen slider when clicking the close button
        $body.on('click', '.swiperLargeViewClose', function () {
            if (commonUtils.fullscreen.isActive()) {
                commonUtils.fullscreen.exit();
            }

            $('.swiperLarge').hide();
            $body.removeClass('swiper-large-image-visible');

            // Re-enable main swiper keyboard
            enableMainSwiperKeyboard();

            fullscreenEventNames.forEach((fullScreenEvent) =>
                document.removeEventListener(fullScreenEvent, fullscreenChangeHandler)
            );

            // Also trigger the keydown event handler removal
            document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', keyCode: 27 }));
        });

        imageSlider.hideThumbnailInSmallView();
        window.addEventListener('resize', imageSlider.hideThumbnailInSmallView);
    },
    hideThumbnailInSmallView() {
        let $parentThumbnail = $('.parentThumbnail');
        if (window.innerWidth <= 700) {
            $parentThumbnail.hide();
        } else if (!$parentThumbnail.is(':visible')) {
            $parentThumbnail.show();
        }
    },
    moveSliderImage() {
        let $activeSlide = $('.swiper-slide-thumb-active').find('img');
        let is_video_url = $activeSlide.data('video-url');
        if (is_video_url) {
            imageSlider.playVideoOnImage(is_video_url, $activeSlide.data('video-type') || '');
        } else {
            let $videoPlay = $('#videoPlay');
            $videoPlay.html('').hide();
            if ($videoPlay.is(':visible')) {
                $('.swiperDetailPage, .playVideoButton').hide();
            } else {
                $('.swiperDetailPage, .playVideoButton').show();
            }
        }
    },
    playVideoOnImage(videoUrl, videoTypeInput) {
        let videoType = videoTypeInput || '';
        let $videoPlay = $('#videoPlay');
        if (!$videoPlay.is(':visible') || videoUrl !== $('#videoFrame').attr('src')) {
            if (videoType === 'Y' && !window.$('#cmp_consent').data('youtube')) {
                commonUtils.showConsentMessage();
                return false;
            }

            if (videoType === 'Y' || videoType === 'V') {
                $('#openFullScreen,a[id^=zoom_image_]').hide();
            }

            $('.swiperDetailPage, .playVideoButton').hide();
            $('#showImage').addClass('video-played');
            $videoPlay.show().html($('#hiddenVideoHtml').html());
            $('#videoFrame').attr('src', videoUrl);
        }

        return undefined;
    },
    showImages() {
        $('#videoPlay').html('').hide();
        $('#showImage').removeClass('video-played');
        $('.swiperDetailPage, .playVideoButton').show();
    },
    playVideoInPopup(videoUrlInput, videoTypeInput) {
        let videoType = videoTypeInput || '';
        if (videoType === 'Y' && !window.$('#cmp_consent').data('youtube')) {
            commonUtils.showConsentMessage();
            return false;
        }
        const videoUrl = videoUrlInput + (videoType === 'V' ? '&dnt=1' : '');
        $.colorbox({
            className: 'ad-video-popup-modal',
            html: `<div class="color-box__video-box"><div class="responsive-video-wrapper"><iframe width="100%" height="auto" allowfullscreen allow="clipboard-write; autoplay; encrypted-media; picture-in-picture" src="${videoUrl}"></iframe></div></div>`,
        });

        return undefined;
    },
};

const AspectRatioHandler = {
    // Function to check the first image's aspect ratio and add a class if it is 3:2
    handleAspectRatioClass() {
        const targetDiv = document.querySelector('.big-image-and-video'); // Target div to add the class
        const firstImage = document.querySelector('.swiper-slide img'); // First image in the slider

        // Ensure the first image exists
        if (!targetDiv || !firstImage) return;

        // Ensure the first image is loaded before calculating aspect ratio
        if (firstImage.complete) {
            this.applyClassFor3to2(targetDiv, firstImage);
        } else {
            firstImage.onload = () => {
                this.applyClassFor3to2(targetDiv, firstImage);
            };
        }
    },

    // Function to calculate aspect ratio and add a class for 3:2 images
    applyClassFor3to2(targetDiv, image) {
        const aspectRatio3to2 = 1.5; // Aspect ratio for 3:2
        const aspectRatio = image.naturalWidth / image.naturalHeight; // Calculate aspect ratio

        // Check if the image is landscape and has an aspect ratio of 3:2
        if (aspectRatio > 1 && Math.abs(aspectRatio - aspectRatio3to2) < 0.01) {
            targetDiv.classList.add('aspect-ratio-3-2'); // Add the class if the aspect ratio is 3:2
        }
    },
};

// Run the script when the DOM content is loaded
document.addEventListener('DOMContentLoaded', () => {
    AspectRatioHandler.handleAspectRatioClass();
});

$(function () {
    imageSlider.init();
});
